import { Link } from "react-router-dom";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";

export default function LandingItalyGo({ data }) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="landing2-go">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-7 col-md-7">
              <div className="land2-go-head italy-land-head">
                <h2 className="heading gradiant-color">{data.title}</h2>
                <span>{data.subTitle}</span>
                <p>{data.desc}</p>
                <Link onClick={() => dispatch(openPopup())} className="default-btn">{data.cta}</Link>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div className="land2-go-img">
                <img loading="lazy" src={data?.rightImg || "/assets/home/land2-go.webp"} alt="whitelabel" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="land2-go-rider">
                <div className="row">

                  {data.boxes && data.boxes.map((box, index) => (
                    <div className="col-lg-6 col-md-6" key={index}>
                      <div className="land2-rider-box">
                        <img loading="lazy" src={box.image} alt="icon" className="img-responsive" />
                        <div>
                          <h3>{box.title}</h3>
                          <p>{box.desc}</p>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="col-lg-12">
                    <div className="land2-rider-butn text-center">
                      <button onClick={() => dispatch(openPopup())} className="default-btn">{data.cta2}</button>
                      <Link to={"/features/taxi-software"}><button className="default-white ">{data.cta3}</button></Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  )
}
